export interface StoreNumberIdentity {
  storeNumber?: string;
  displayStoreNumber?: string;
  starbucksStoreNumber?: string;
}

export const getDisplayStoreNumber = (store?: StoreNumberIdentity | null): string =>
  store?.displayStoreNumber || store?.starbucksStoreNumber || store?.storeNumber || '';

export const getDisplayStoreNumberByInternal = (
  stores: readonly StoreNumberIdentity[] | undefined,
  storeNumber: string | undefined,
): string => {
  const store = stores?.find(item => item.storeNumber === storeNumber);
  return getDisplayStoreNumber(store) || storeNumber || '';
};